import config from './config';

// API helpers for cart persistence
const API_BASE = `${config.API_BASE_URL}/Cart`;

/**
 * Fetch cart for a specific branch (or global cart when branchId is null).
 * Backend returns an array of cart items.
 */
export async function fetchCart(userId, branchId = null) {
  if (!userId) {
    console.log('fetchCart: No userId, skipping network request.');
    return [];
  }

  try {
    let url = `${API_BASE}/Get?userId=${userId}`;
    if (branchId !== null && branchId !== undefined && branchId !== '') {
      url += `&branchId=${branchId}`;
    }

    const res = await fetch(url);
    if (!res.ok) throw new Error('Failed to fetch cart');

    const data = await res.json();
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.items)) return data.items;
    return [];
  } catch (error) {
    console.error('❌ Error fetching cart:', error);
    return [];
  }
}

/**
 * Save cart for a specific branch (or global cart when branchId is null).
 * Each item in the payload also carries its own BranchId so the backend
 * can correctly tag connected-branch items.
 *
 * Backend may return:
 *   - { userId, branchId, items, count }   (new shape)
 *   - [...items]                            (old shape)
 *
 * Always returns an array (or [] on failure).
 */
export async function saveCart(userId, cart, branchId = null) {
  if (!userId) {
    console.log('saveCart: No userId, skipping network request.');
    return [];
  }

  try {
    let url = `${API_BASE}/Save?userId=${userId}`;
    if (branchId !== null && branchId !== undefined && branchId !== '') {
      url += `&branchId=${branchId}`;
    }

    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cart),
    });

    if (!res.ok) throw new Error('Failed to save cart');

    const data = await res.json().catch(() => null);

    if (data && Array.isArray(data.items)) return data.items;
    if (Array.isArray(data)) return data;
    return [];
  } catch (error) {
    console.error('❌ Error saving cart:', error);
    return [];
  }
}